<template>
    <div>
        <LeaveSummaryChart />
        <UpcomingLeaves />
        <EmployeeSearch />
    </div>
</template>

<style scoped lang="scss"></style>

<script setup>
import LeaveSummaryChart from '@/components/Admin/LeaveSummary/LeaveSummaryChart.vue';
import UpcomingLeaves from '@/components/Admin/LeaveSummary/UpcomingLeaves.vue';
import EmployeeSearch from '@/components/Admin/LeaveSummary/EmployeeSearch.vue';
export default {
    components: { LeaveSummaryChart, UpcomingLeaves, EmployeeSearch },
};
</script>
